export type MemberType = "personal" | "business";

export interface SignupBusinessDraft {
  managerName: string;
  managerPhone: string;
  companyName: string;
  representativeName: string;
  registrationNumber: string;
  address: string;
  addressDetail: string;
  companyEmail: string;
  registrationFileId: string | null;
}

export interface SignupDraft {
  loginId?: string;
  password?: string;
  name?: string;
  birthDate?: string;
  gender?: string;
  phone?: string;
  email?: string;
  memberType?: MemberType;
  business?: SignupBusinessDraft;
  consentIds?: string[];
  verificationId?: string;
}

export interface MemberSession {
  id: string;
  managementCode: string;
  loginId: string;
  email: string;
  name: string;
  memberType: MemberType;
  companyName: string | null;
  phone: string;
  birthDate: string;
  gender: "male" | "female";
  profileFileId: string | null;
  business: SignupBusinessDraft | null;
}

const draftKey = "calwalk-signup-draft";
const memberKey = "calwalk-auth-member";

export function readSignupDraft(): SignupDraft {
  try { return JSON.parse(sessionStorage.getItem(draftKey) || "{}"); }
  catch { return {}; }
}

export function writeSignupDraft(values: Partial<SignupDraft>) {
  sessionStorage.setItem(draftKey, JSON.stringify({ ...readSignupDraft(), ...values }));
}

export function clearSignupDraft() {
  sessionStorage.removeItem(draftKey);
}

export function saveMemberSession(member: MemberSession) {
  sessionStorage.setItem(memberKey, JSON.stringify(member));
}

export function readMemberSession(): MemberSession | null {
  try { return JSON.parse(sessionStorage.getItem(memberKey) || "null"); }
  catch { return null; }
}

export function clearMemberSession() {
  sessionStorage.removeItem(memberKey);
}
